import React from 'react';

export const ResearchPage: React.FC = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Research Tree
      </h1>
      <p className="text-muted-foreground">
        Research tree will be implemented here
      </p>
    </div>
  );
};